import React from "react";

export type CategoryType = "PROJECT" | "ENTERTAINMENT" | "RANDOM" | "IMAGE";

export type BaseItem = {
id: number;
category: CategoryType;
author: string;
handle: string;
timestamp: string;
content: string;
stats: {
    comments: number;
    retweets: number;
    likes: number;
    views: string;
};
};

export type ProjectItem = BaseItem & {
type: "project";
projectData: {
    name: string;
    icon: React.ReactNode;
    playable: boolean;
    path?: string;
    mode: "playable" | "video";
    banner_image?: string;
};
videoUrl?: string;
imageUrl?: string;
};

export type VideoItem = BaseItem & {
type: "video";
videoUrl: string;
};

export type ImageItem = BaseItem & {
type: "image";
imageUrl: string;
};

export type TextItem = BaseItem & {
type: "text";
};

export type DocumentItem = BaseItem & {
    type: "document";
    fileUrl: string;
    fileType: "pdf" | "ppt" | "pptx";
    thumbnailUrl?: string;
};

export type FeedItem = ProjectItem | VideoItem | ImageItem | TextItem | DocumentItem;;

export const feedItems: FeedItem[] = [
{
    id: 102,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_1",
    content: "KatzWords",
    projectData: {
    name: "MyCapture",
    icon: "🐈‍⬛",
    playable: true,
    path: "/showcase/katz",
    mode: "playable"
    },
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 101,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_1",
    content: "MyCapture",
    projectData: {
    name: "MyCapture",
    icon: "🔍",
    playable: true,
    path: "https://mycapture.kproject31.my.id/",
    mode: "playable"
    },
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 100,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_1",
    content: "Luck Or Death",
    projectData: {
    name: "Luck Or Death",
    icon: "♞",
    playable: true,
    path: "/showcase/chess",
    mode: "playable"
    },
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 99,
    type: "document",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_3",
    content: "FMCG_Report",
    fileUrl: "/documents/Data_Analyst.pdf",
    fileType: "pdf",
    thumbnailUrl: "/pochita.png",
    stats: {
        comments: 1,
        retweets: 3,
        likes: 130,
        views: "75K"
    }
},
{
    id: 98,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_2",
    content: "Web_Blog_App",
    projectData: {
    name: "Web_Blog_App",
    icon: "🎬",
    playable: false,
    mode: "video"
    },
    videoUrl: "https://www.youtube.com/embed/SCQ_s8abutE?si=OZBXwRbtgxRO9W3i",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 97,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_2",
    content: "K_Marketing",
    projectData: {
    name: "K_Marketing",
    icon: "🎬",
    playable: false,
    mode: "video"
    },
    videoUrl: "https://www.youtube.com/embed/tHfm23st8uA",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 96,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_2",
    content: "KMeansRFM_Customer_Analysis",
    projectData: {
    name: "KMeansRFM_Customer_Analysis",
    icon: "🎬",
    playable: false,
    mode: "video"
    },
    videoUrl: "https://www.youtube.com/embed/uPOet9tqugI",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 95,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_2",
    content: "K_Finance",
    projectData: {
    name: "K_Finance",
    icon: "🎬",
    playable: false,
    mode: "video"
    },
    videoUrl: "https://www.youtube.com/embed/Edm8aiezaf8",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 94,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_2",
    content: "MyCapture_Detection",
    projectData: {
    name: "MyCapture_Detection",
    icon: "🎬",
    playable: false,
    mode: "video"
    },
    videoUrl: "https://www.youtube.com/embed/mFGH3Z1jtrY",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 93,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_2",
    content: "Yolo_V5_Algorithm",
    projectData: {
    name: "YOLO V5 Algorithm",
    icon: "🎬",
    playable: false,
    mode: "video"
    },
    videoUrl: "https://www.youtube.com/embed/kxsruHbpq9U",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 92,
    type: "project",
    category: "PROJECT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "P_3",
    content: "Laravel_Vue_JS",
    projectData: {
    name: "Laravel Vue Web App",
    icon: "🎬",
    playable: false,
    mode: "video"
    },
    videoUrl: "https://www.youtube.com/embed/JYRIzF_QtZg",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},

{
    id: 87,
    type: "video",
    category: "RANDOM",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "[*] ",
    videoUrl: "https://www.youtube.com/embed/7ryzRsoJ8gY?si=wXcHgu_B6HCW6wvA",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 86,
    type: "video",
    category: "RANDOM",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "[*] ",
    videoUrl: "https://www.youtube.com/embed/yepawTVTnuk?si=R9ssdQggmsM2iRvm",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 82,
    type: "video",
    category: "ENTERTAINMENT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_1",
    content: "Comedy La Mandragola",
    videoUrl: "https://www.youtube.com/embed/wOneUVojhkk?si=cqozlsWil4-jqEtH",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 81,
    type: "video",
    category: "ENTERTAINMENT",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_1",
    content: "Free Solo Climber.",
    videoUrl: "https://www.youtube.com/embed/BE8ebLVfj6Y",
    stats: { comments: 1, retweets: 3, likes: 130, views: "75K" }
},
{
    id: 79,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "Journey To The West",
    imageUrl: "wukong.png",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" }
},
{
    id: 78,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "Through the looking glass ",
    imageUrl: "MyChess.png",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" }
},
{
    id: 77,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "The Feast of the Goat",
    imageUrl: "MyIgoo.png",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" }
},

{
    id: 76,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "The Statue of the Forgotten City",
    imageUrl: "/MyPlace.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" }
},

];